module.exports = __webpack_public_path__ + "static/media/doremi_de_2.1a5e6bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/doremi_de_2.png
// module id = 167
// module chunks = 0